import * as t from 'io-ts';

import {makeApiType, RLazyTeammateIdRef} from './apiTypes';

/*
 * Runtime type.
 */

const RSeenByDirty = t.readonly(
  t.type({
    teammateId: RLazyTeammateIdRef,
    seenAt: t.union([t.null, t.Integer]),
    autoSeenAt: t.union([t.null, t.Integer]),
  }),
);

/*
 * Type.
 */

export interface SeenByModel extends t.TypeOf<typeof RSeenByDirty> {}
export const RSeenBy = t.clean<SeenByModel>(RSeenByDirty as any);
const RSeenByList = t.readonlyArray(RSeenBy);

/*
 * IO methods.
 */

export function parseSeenBy(src: any): SeenByModel {
  return {
    teammateId: src.teammate_id,
    seenAt: src.seen_at ?? null,
    autoSeenAt: src.auto_seen_at ?? null,
  };
}

export function parseSeenByList(src: any): ReadonlyArray<SeenByModel> {
  return src.seen_by && src.seen_by.map(parseSeenBy);
}

/*
 * API type.
 */

export const ApiSeenBy = makeApiType('seenBy', RSeenBy, parseSeenBy);
export const ApiSeenByList = makeApiType('seenByList', RSeenByList, parseSeenByList);
